import { object, string, number } from "yup";

export const smsSnippetSchema = object({
  id: number().required(),
  name: string().required(),
  title: string().required(),
  phrase: string().required(),
});
